import { render, staticRenderFns } from "./LobbyInstructionModal.vue?vue&type=template&id=049888de&"
import script from "./LobbyInstructionModal.vue?vue&type=script&lang=js&"
export * from "./LobbyInstructionModal.vue?vue&type=script&lang=js&"
import style0 from "./LobbyInstructionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports